var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50065 6.33325H5.00065C4.08018 6.33325 3.33398 7.07944 3.33398 7.99992V15.4999C3.33398 16.4204 4.08018 17.1666 5.00065 17.1666H12.5007C13.4211 17.1666 14.1673 16.4204 14.1673 15.4999V12.9999",
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50065 6.33325H5.00065C4.08018 6.33325 3.33398 7.07944 3.33398 7.99992V15.4999C3.33398 16.4204 4.08018 17.1666 5.00065 17.1666H12.5007C13.4211 17.1666 14.1673 16.4204 14.1673 15.4999V12.9999",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13H10L17.0833 5.91669C17.7737 5.22634 17.7737 4.10705 17.0833 3.41669C16.393 2.72634 15.2737 2.72634 14.5833 3.41669L7.5 10.5V13",
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13H10L17.0833 5.91669C17.7737 5.22634 17.7737 4.10705 17.0833 3.41669C16.393 2.72634 15.2737 2.72634 14.5833 3.41669L7.5 10.5V13",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 4.66675L15.834 7.16675",
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 4.66675L15.834 7.16675",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c77fa29deba41d4535d8a9cf68234f3c.svg";
export { ForwardRef as ReactComponent };